// extracted by mini-css-extract-plugin
export default {"exceptionSection":"exceptionSection---yCAnU","exceptionAddButton":"exceptionAddButton---u03Bm"};